<style src="css/index.css" scoped></style>
<template>
  <div class="containerBox" style="padding-bottom: 1.24rem">
    <div class="topBox">
      <img class="logo" src="../assets/common/logo.png" />
      <div class="signOut"></div>
      专家端
      <div class="signOut" @click="signOut">退出</div>
    </div>
    <div class="banner"></div>
    <div class="box">
      <div class="orderList">
        <div class="orderItem" @click="to(`psychology?current=0`)">
          全部订单
          <div class="num">
            {{
              doctorServeData[0].totalCount +
              doctorServeData[1].totalCount +
              doctorServeData[2].totalCount
            }}
          </div>
        </div>
        <div class="orderItem" @click="to(`psychology?current=1`)">
          待咨询
          <div class="num" :class="{ active: doctorServeData[0].totalCount }">
            {{ doctorServeData[0].totalCount }}
          </div>
        </div>
        <div class="orderItem" @click="to(`psychology?current=2`)">
          进行中
          <div class="num">{{ doctorServeData[1].totalCount }}</div>
        </div>
        <div class="orderItem" @click="to(`psychology?current=3`)">
          已完成
          <div class="num">{{ doctorServeData[2].totalCount }}</div>
        </div>
      </div>

      <div class="blockBox">
        <div class="title serviceSettings">
          <div class="icon"></div>
          服务设置
        </div>
        <div class="serviceSettingsItemList">
          <div class="serviceSettingsItem">
            <div class="left">
              <div class="leftIcon s1"></div>
              <span style="min-width: 1.25rem">线下咨询</span>
            </div>
            <div
              class="right"
              :class="{ active: doctorServe.offline }"
              @click="setStatus('offline', doctorServe.offline)"
            ></div>
          </div>
          <div
            style="margin-left: 0.88rem; word-break: break-all"
            v-if="doctorServe.remark && doctorServe.offline"
          >
            (线下地址：{{ doctorServe.remark }})
          </div>
        </div>

        <div class="serviceSettingsItem">
          <div class="left">
            <div class="leftIcon s2"></div>
            视频咨询
          </div>
          <div
            class="right"
            :class="{ active: doctorServe.video }"
            @click="setStatus('video', doctorServe.video)"
          ></div>
        </div>
        <div class="serviceSettingsItem">
          <div class="left">
            <div class="leftIcon s3"></div>
            语音咨询
          </div>
          <div
            class="right"
            :class="{ active: doctorServe.telephone }"
            @click="setStatus('telephone', doctorServe.telephone)"
          ></div>
        </div>
        <div class="serviceSettingsItem">
          <div class="left">
            <div class="leftIcon s4"></div>
            图文咨询
          </div>
          <div
            class="right"
            :class="{ active: doctorServe.imageText }"
            @click="setStatus('imageText', doctorServe.imageText)"
          ></div>
        </div>
      </div>

      <div class="blockBox">
        <div class="title">
          <div class="icon"></div>
          常用功能
        </div>
        <div class="functionList">
          <div
            class="functionItem"
            v-for="item in functionList"
            v-if="!(companyId == '10006' && item.name == '讲座会诊')"
            @click="to(item.url)"
          >
            <img class="functionItemIcon" :src="EnvUrl + item.icon" alt="" />
            {{ item.name }}
          </div>
          <div class="functionItem" @click="agreementBox = true">
            <img class="functionItemIcon" :src="EnvUrl + 'fun5.png'" alt="" />
            创作中心
          </div>
        </div>
      </div>
    </div>

    <div class="maskBox" v-if="maskStatus">
      <div class="mask">
        <div class="maskTop">
          <div class="maskTitle">线下咨询地址</div>
          <div class="selectBox" v-if="companyId == '10006'">
            <div
              class="selectItem"
              @click="changeRemark('南山校区心理咨询室7号楼二楼（医务室楼上）')"
            >
              <div
                class="resultType"
                :class="{
                  active:
                    remark === '南山校区心理咨询室7号楼二楼（医务室楼上）',
                }"
              ></div>
              南山校区心理咨询室7号楼二楼（医务室楼上）
            </div>
            <div
              class="selectItem"
              @click="changeRemark('象山校区心理咨询室11号楼105')"
            >
              <div
                class="resultType"
                :class="{ active: remark === '象山校区心理咨询室11号楼105' }"
              ></div>
              象山校区心理咨询室11号楼105
            </div>
            <div
              class="selectItem"
              @click="
                changeRemark(
                  '【周一】南山校区心理咨询室7号楼二楼（医务室楼上）；【其他时间】象山校区心理咨询室11号楼105'
                )
              "
            >
              <div
                class="resultType"
                :class="{
                  active:
                    remark ===
                    '【周一】南山校区心理咨询室7号楼二楼（医务室楼上）；【其他时间】象山校区心理咨询室11号楼105',
                }"
              ></div>
              【周一】南山校区心理咨询室7号楼二楼（医务室楼上）；【其他时间】象山校区心理咨询室11号楼105
            </div>
            <div
              class="selectItem"
              @click="
                changeRemark(
                  '【周一】象山校区心理咨询室11号楼105；【其他时间】南山校区心理咨询室7号楼二楼（医务室楼上）'
                )
              "
            >
              <div
                class="resultType"
                :class="{
                  active:
                    remark ===
                    '【周一】象山校区心理咨询室11号楼105；【其他时间】南山校区心理咨询室7号楼二楼（医务室楼上）',
                }"
              ></div>
              【周一】象山校区心理咨询室11号楼105；【其他时间】南山校区心理咨询室7号楼二楼（医务室楼上）
            </div>
          </div>
          <textarea placeholder="输入地址" v-model="remark" v-else></textarea>
          <!--                    <input type="text" maxlength="30" placeholder="最多输入30个字" v-model="remark">-->
        </div>
        <div class="btnBox">
          <div class="btn" @click="cancle">取消</div>
          <div class="btn active" @click="cancelUserBespeak">提交</div>
        </div>
      </div>
    </div>
    <div class="agreementBox" v-if="agreementBox">
      <div class="agreement">
        <div class="agreementTitle">服务协议和隐私政策</div>
        <div class="agreementContent">
          感谢选择我们这个平台，我们非常重视您的个人信息安全和隐私保护。依据最新法律要求，使用我们的产品功能前，请仔细阅读并同意
          <span @click="to('rules')">《服务协议和隐私政策》</span>，以
          便我们向你提供更优质的服务！
        </div>
        <div class="agreementContent">
          我们承若将尽全力保护你个人信息及合法权益，再次感谢您的信任！
        </div>
        <div class="agree" @click="to('article')">同意并继续</div>
        <div class="disagree" @click="agreementBox = false">不同意</div>
      </div>
    </div>

    <footerBox active="1"></footerBox>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";
import topbar from "components/topbar";
import footerBox from "components/footer";
import noMoreData from "components/no-more-data";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      doctorId: '',
      companyId: localStorage.getItem("companyId")
        ? localStorage.getItem("companyId")
        : "",
      doctorServe: {},
      maskStatus: false,
      remark: "",
      agreementBox: false,
      doctorServeData: [
        {
          totalCount: 0,
        },
        {
          totalCount: 0,
        },
        {
          totalCount: 0,
        },
      ],
      functionList: [
        {
          name: "心理咨询",
          icon: "fun1.png",
          url: "psychology",
        },
        {
          name: "个人资料",
          icon: "fun2.png",
          url: "personalData",
        },
        // {
        //     name: '我的用户',
        //     icon: 'fun3.png',
        //     url: 'myUsers'
        // },
        {
          name: "排班时间",
          icon: "fun4.png",
          url: "scheduling",
        },
        // {
        //     name: '创作中心',
        //     icon: 'fun5.png',
        //     url: 'creat',
        // },
        {
          name: "咨询协议",
          icon: "fun666.png",
          url: "rule",
        },
        {
          name: "请假处理",
          icon: "fun7.png",
          url: "leave",
        },
        {
          name: "讲座会诊",
          icon: "fun3.png",
          url: "offlineLectures",
        },
        {
          name: "咨询排班",
          icon: "fun9.png",
          url: "consultingScheduling",
        },
      ],
    };
  },
  components: {
    topbar,
    noMoreData,
    footerBox,
  },
  computed: {},
  methods: {
    changeRemark(n) {
      this.remark = n;
    },
    async scaleDoctorHome() {
      let id = this.doctorId
      if (id === 'null') id = ''
      let data = await getSources(
        "/bear-scale/api/chatDoctor/scaleDoctorHome.json",
        { doctorId: id }
      );
      if (data.status === 0) {
        this.doctorServe = data.doctorServe;
        this.doctorServeData = data.doctorServeData;
        if (data.doctorServe.remark) {
          this.remark = data.doctorServe.remark;
        }
        if (data.warnType) {
          alert(data.warnMsg);
        }
      } else {
        alert(data.msg);
      }
    },
    setStatus(a, b) {
      if (a === "offline" && b === 0) {
        this.maskStatus = true;
      } else {
        if (b) {
          b = 0;
        } else {
          b = 1;
        }
        this.chatDoctorServeSet(a, b);
      }
    },
    cancle() {
      this.maskStatus = false;
      // this.remark = ''
    },

    async cancelUserBespeak() {
      if (!this.remark) {
        alert(`请输入地址`);
        return;
      }
      let data = await getSources(
        "/bear-scale/api/chatDoctor/chatDoctorServeSet.json",
        { serveId: this.doctorServe.serveId, offline: 1, remark: this.remark }
      );
      if (data.status === 0) {
        this.cancle();
        this.scaleDoctorHome();
      } else {
        alert(data.msg);
      }
    },
    async chatDoctorServeSet(a, b) {
      let data = await getSources(
        "/bear-scale/api/chatDoctor/chatDoctorServeSet.json",
        { serveId: this.doctorServe.serveId, [a]: b }
      );
      if (data.status === 0) {
        this.scaleDoctorHome();
      } else {
        alert(data.msg);
      }
    },

    signOut() {
      let aa = "";
      let bb = "";
      if (localStorage.getItem("token")) {
        aa = localStorage.getItem("token");
      }
      if (localStorage.getItem("id")) {
        bb = localStorage.getItem("id");
      }
      console.log(aa);
      localStorage.clear();
      // localStorage.removeItem('doctorId')
      // localStorage.removeItem('doctorName')
      if (aa) {
        console.log(aa);
        localStorage.setItem("token", aa);
      }
      if (bb) {
        console.log(bb);
        localStorage.setItem("id", bb);
      }
      if (!localStorage.getItem("doctorId")) {
        this.$router.push(`/login`);
      } else {
        setTimeout(() => {
          this.$router.push(`/login`);
        }, 200);
      }
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
  },
  mounted() {
    let doctorId = localStorage.getItem("doctorId")
    if (!doctorId || doctorId === 'null'|| doctorId === 'undefined'|| typeof doctorId === 'undefined' ) doctorId = ''
    if (!doctorId) {
      if (this.$route.query.code) {
        this.$router.push(
          `/login?next=${encodeURIComponent(this.$route.fullPath)}&code=${
            this.$route.query.code
          }`
        );
      } else {
        this.$router.push(
          `/login?next=${encodeURIComponent(this.$route.fullPath)}`
        );
      }
      return
    }
    this.doctorId = doctorId
    this.scaleDoctorHome();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/index.vue